export enum STATUS {
  idle = 'idle',
  loading = 'loading',
  reloading = 'reloading',
  loaded = 'loaded',
  notFound = 'notFound',
  failed = 'failed',
}
